import { render, staticRenderFns } from "./courseAdult.vue?vue&type=template&id=3057b7f0&scoped=true"
import script from "./courseAdult.vue?vue&type=script&lang=js"
export * from "./courseAdult.vue?vue&type=script&lang=js"
import style0 from "./courseAdult.vue?vue&type=style&index=0&id=3057b7f0&lang=scss"
import style1 from "./courseAdult.vue?vue&type=style&index=1&id=3057b7f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057b7f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3057b7f0')) {
      api.createRecord('3057b7f0', component.options)
    } else {
      api.reload('3057b7f0', component.options)
    }
    module.hot.accept("./courseAdult.vue?vue&type=template&id=3057b7f0&scoped=true", function () {
      api.rerender('3057b7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/course/courseAdult.vue"
export default component.exports